export default {
  'activityLog.name': 'Nhật ký hoạt động',
  'activityLog.table.userName': 'Tên đăng nhập',
  'activityLog.table.typeAccount': 'Loại tài khoản',
  'activityLog.table.group': 'Nhóm người dùng',
  'activityLog.table.system': 'Hệ thống tác động',
  'activityLog.table.impactTime': 'Thời gian tác động',
  'activityLog.table.performedAction': 'Thao tác thực hiện',
};
